/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isNumberType
 */

export default function isNumberType(value) {
  return typeof value === 'number';
}
